// START OF COORD PAGE JAVASCRIPT

function SetMasterSelect( select, id )
{
    select.selectedIndex = -1;
    for ( var i = 0; i < select.options.length; i++ )
    {
        if ( select.options[ i ] .value == id )
        {
            select.selectedIndex = i;
            select.dispatchEvent( new Event( "change" ) );
            break;
        }
    }
}

function HandleVariantClick(e) {
  e.preventDefault();
  e.stopPropagation();
  var form = e.currentTarget.closest("form");
  var id = e.currentTarget.getAttribute("for");
  var input = form.querySelector("#" + id);
  if (input.checked) {
    input.checked = false;
  } else {
    input.checked = true;
  }
  if (input.classList.contains("ImAPrimaryInput")) 
  {
    var button = document.querySelector(".add-to-cart-btn");
    if (input.classList.contains("disabled"))
    {
      button.innerHTML=button.getAttribute ("data-state-soldout");
      button.setAttribute ("disabled","disabled");
    }
    else
    {
      button.innerHTML=button.getAttribute ("data-state-available");
      button.removeAttribute ("disabled");
    }
    SetMasterSelect( document.querySelector( "select[name='id']" ), GetPrimaryVariantID( ) );
  }
  else
  {
      SetMasterSelect( document.querySelector( ".secondary_form_options select[name='secondary-id']" ), GetSecondaryVariantID( ) );
  }
}


function GetPrimaryVariantID() {
  var result;
  var primarySelectedVariants = document.querySelectorAll(".primary_form_options input:checked");
  for (var i = 0; i < primaryProductData.length; i++) {
    var product = primaryProductData[i];
    var matches = 0;
    var numberOfOptionsInProduct = 1;
    if (product.option2 != "") {
      if (product.option3 != "") {
        numberOfOptionsInProduct = 3;
      } else {
        numberOfOptionsInProduct = 2;
      }
    }
    for (var j = 0; j < primarySelectedVariants.length; j++) {
      var primarySelectedVariant = primarySelectedVariants[j];
      var optionIndex = primarySelectedVariant.getAttribute("data-optionindex");
      var optionValue = primarySelectedVariant.value;
      var propertyName = "option" + optionIndex;
      if (product[propertyName] == optionValue) {
        matches++;
      }
    }
    if (matches == numberOfOptionsInProduct) {
      result = product.variantid;
      break;
    }
  }
  return result;
}


function GetSecondaryVariantID() {
  var result2;
  var secondarySelectedVariants = document.querySelectorAll(".secondary_form_options input:checked:not(.disabled)");
  for (var k = 0; k < secondaryProductData.length; k++) {
    var product2 = secondaryProductData[k];
    var matches2 = 0;
    var numberOfOptionsInProduct = 1;
    if (product2.option2 != "") {
      if (product2.option3 != "") {
        numberOfOptionsInProduct = 3;
      } else {
        numberOfOptionsInProduct = 2;
      }
    }
    for (var l = 0; l < secondarySelectedVariants.length; l++) {
      var secondarySelectedVariant = secondarySelectedVariants[l];
      var optionIndex = secondarySelectedVariant.getAttribute("data-optionindex");
      var optionValue = secondarySelectedVariant.value;
      var propertyName = "option" + optionIndex;
      if (product2[propertyName] == optionValue) {
        matches2++;
      }
    }
    if (matches2 == numberOfOptionsInProduct) {
      result2 = product2.variantid;
      break;
    }
  }
  return result2;
}




function SendVariantIDsToShopify(primaryID, secondaryID, cb) {
  let formData = {
    'items': []
  };
  if (primaryID) {
    formData.items.push({
      'id': primaryID,
      'quantity': 1
    });
  }
  if (secondaryID) {
    formData.items.push({
      'id': secondaryID,
      'quantity': 1
    });
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)

  }).then(response => {
    // when you see response => { } it means function( response ) { }
    cb();

  }).catch((error) => {
    console.error('Error:', error);
  });
}



function HandleAddToCart(e)
{
  e.preventDefault();
  e.stopPropagation();
  //Select Colour Before Add to Cart
  var optionGroups = document.querySelectorAll('.primary_form_options .product-page__form__options__item');
  optionGroups.forEach( function( element ) 
  {
    var InputElements = element.querySelectorAll("input");
    if (InputElements.length == 1){
      InputElements[0].checked=true;
    }
  });
  //Get variant IDs
  var primaryID = GetPrimaryVariantID();
  var secondaryID = GetSecondaryVariantID();


  //Send variants to Shopify
  SendVariantIDsToShopify(primaryID, secondaryID, function (Result) {
    //Handle response
    console.log("TESTCART");
    var event = new Event('added-item');
    document.dispatchEvent(event);
  });

}




function SetupCoordFormEvent() {
  var variants = document.querySelectorAll('.product-page__form__options__swatch');
  for (var i = 0; i < variants.length; i++) {
    var variant = variants[i];
    variant.addEventListener("click", HandleVariantClick);
  }
  // variants.forEach(function(e) {
  // e.addEventListener('change', );
  //});
  var element = document.querySelector(".product-page .add-to-cart-btn");
  element.addEventListener("click", HandleAddToCart);
}

// this needs to be here for the Swym Back in Stock trigger. 
const variantChange = () => {
  $('[data-handle="variant-button"]').on( "click", function() {
   const variantID = $(this).data('variant');
   window.history.replaceState(null, null, `?variant=${variantID}`);
  } );
}



$(document).ready(function () {
  console.log("WTF********");
  SetupCoordFormEvent();
  variantChange();
});

// END OF COORD PAGE JAVASCRIPT